import { render, staticRenderFns } from "./PavilionButton.vue?vue&type=template&id=93c6462e&scoped=true"
import script from "./PavilionButton.vue?vue&type=script&lang=ts"
export * from "./PavilionButton.vue?vue&type=script&lang=ts"
import style0 from "./PavilionButton.vue?vue&type=style&index=0&id=93c6462e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c6462e",
  null
  
)

export default component.exports